import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router-dom';
import theme from 'tailwindcss/defaultTheme';
import { setIsMobileViewActions, setIsTabletViewActions } from '../redux/actions/screenActions';
import Sidebar from './sidebar';
import Topbar from './topbar';

const PrivateLayout = ({ userData }) => {
  const dispatch = useDispatch();

  const isMobileView = !useMediaQuery({
    query: `(min-width : ${theme.screens.md})`,
  });

  const isTabletView = !useMediaQuery({
    query: `(min-width : ${theme.screens.xl})`,
  });

  useEffect(() => {
    dispatch(setIsMobileViewActions(isMobileView));
    dispatch(setIsTabletViewActions(isTabletView));
  }, [dispatch, isMobileView, isTabletView]);

  const [showSidebar, setShowSidebar] = useState(!isTabletView);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar
        userData={userData}
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        isTabletView={isTabletView}
      />
      <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden bg-white">
        <Topbar userData={userData} setShowSidebar={setShowSidebar} />
        <main>
          <div className="mx-auto max-w-screen-xl px-2 pb-2 pt-4 sm:p-4 md:p-8 justify-center">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default PrivateLayout;
